import { Card } from '@mui/material'
import SoftButton from 'components/SoftButton'
import Footer from 'examples/Footer'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { api } from 'utils/Api'
import DetailBox from 'utils/Detail-Box/DetailBox'
import UnitsData from './Unit/UnitsData'
import Tenant from './Tenant/Tenant'
import { useHierarchy } from 'context/HierarchyContext'

function PropertyDetail() {
    const [allProperties, setAllProperties] = useState([]);
    const { orgCode, propertyCode, propertyDetailTab } = useParams();
    const [propertyData, setPropertyData] = useState({});
    const navigate = useNavigate();
    const { orgId, propertyId } = useHierarchy();

    //data fetching logic
    useEffect(() => {
        if (allProperties.length > 0 && orgId) {
            const selectedOrg = allProperties.find(pro => pro.organization_id === parseInt(orgId) && pro.id === parseInt(propertyId));
            if (selectedOrg) {
                setPropertyData(selectedOrg);
            }
        }
    }, [allProperties, orgId]);

    const fetchPropertiesData = async () => {
        try {
            const response = await api.su_Property.getSuProperties();
            setAllProperties(response);
        } catch (e) {
        }   
    };

    useEffect(() => {
        fetchPropertiesData();
    }, []);

    // If URL is just /super-admin/organization → redirect to default tab
    useEffect(() => {
        if (!propertyDetailTab) {
            navigate(`/super-admin/organization/${orgCode}/properties/${propertyCode}/${activeTab}`, { replace: true });
        }
    }, [propertyDetailTab, navigate]);

    const activeTab = propertyDetailTab || "unit";

    return (
        <DashboardLayout>
            <DashboardNavbar />
                <DetailBox
                title={`${propertyData?.name } (${propertyData?.property_code}) ` || "Property Details"}
                    data={propertyData}
                    inputs={[
                        // { label: "Properties Name", key: "name" },
                        // { label: "Property Code", key: "property_code" },
                        { label: "city", key: "city" },
                        { label: "State", key: "state" },
                        { label: "Country", key: "country" },
                        { label: "Pincode", key: "pin_code" },
                        { label: "Description", key: "description" },
                    ]}
                />
            <Card
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    mb: 1,
                    p: 1,
                    background: "#f5f7fa",
                    borderRadius: "10px",
                    width: "fit-content",
                }}
                >
                <SoftButton
                    onClick={() => navigate(`/super-admin/organization/${orgCode}/properties/${propertyCode}/unit`)}
                    size="small"
                    sx={{
                    px: 3,
                    borderRadius: "8px",
                    fontWeight: 600,
                    backgroundColor: activeTab === "unit" ? "#e3f2fd" : "#ffffff",
                    color: activeTab === "unit" ? "#03a9f4" : "#9e9e9e",
                    border: "2px solid",
                    borderColor: activeTab === "unit" ? "#b3e5fc" : "#e0e0e0",
                    borderBottom: "none",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    boxShadow: activeTab === "unit" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
                    "&:hover": {
                        backgroundColor: activeTab === "unit" ? "#e1f5fe" : "#fafafa",
                    },
                    }}
                >
                    Unit
                </SoftButton>
        
                <SoftButton
                    onClick={() => navigate(`/super-admin/organization/${orgCode}/properties/${propertyCode}/residents`)}
                    size="small"
                    sx={{
                    px: 3,
                    ml: 1,
                    borderRadius: "8px",
                    fontWeight: 600,
                    backgroundColor: activeTab === "residents" ? "#e3f2fd" : "#ffffff",
                    color: activeTab === "residents" ? "#03a9f4" : "#9e9e9e",
                    border: "2px solid",
                    borderColor: activeTab === "residents" ? "#b3e5fc" : "#e0e0e0",
                    borderBottom: "none",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    boxShadow: activeTab === "residents" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
                    "&:hover": {
                        backgroundColor: activeTab === "residents" ? "#e1f5fe" : "#fafafa",
                    },
                    }}
                >
                    Residents
                </SoftButton>
                  </Card>
            {/* Tab Content */}
            {activeTab === "unit" && <UnitsData />}
            {activeTab === "residents" && <Tenant />}
            <Footer />
        </DashboardLayout>
    )
}

export default PropertyDetail